module.exports = __webpack_public_path__ + "img/126.0bd76b52.png";